import {gql} from '@apollo/client';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {EntityType} from 'constants/UserConstants';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {Party} from 'parties/PartyConstants';

export const PARTY_INPUT_QUERY = gql`
  query PartyInputQuery($ids: [StrictString!]!) @skipAudit @engComponent(name: IDENTITY) {
    parties(ids: $ids) {
      ... on UserNode {
        id
        name
        handle
        email
      }
      ... on PartyInterface {
        id
        name
        handle
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const CUSTOM_PARTY = 'custom_party';

export type EntityWithText = Party & {
  text: string;
  email?: string;
};

export type EntityWithTextAndSuspended = EntityWithText & {
  suspended?: boolean;
};

export interface MinimalEntity {
  handle: string;
  id: string;
  name?: string;
  avatarUrl?: string | null;
}

export interface EntitySuggestion extends MinimalEntity {
  text?: string;
  email?: string;
  type?: EntityType | ModelTypeConstants.TEAM;
  name?: string;
  suspended?: boolean;
}

export interface CustomParty {
  type: typeof CUSTOM_PARTY;
  text: string;
}

export const NULL_PARTY_OPTION = 'None';
export const NULL_PARTY: CustomParty = {
  type: CUSTOM_PARTY,
  text: NULL_PARTY_OPTION,
};
